import { useQuery } from '@tanstack/react-query';
import { getRealtimeRisk } from '../api/client';

export function useRealtimeRisk(
  point: { lat: number; lon: number } | null,
  runId?: string
) {
  return useQuery({
    queryKey: ['realtimeRisk', point?.lat, point?.lon, runId],
    queryFn: () =>
      point ? getRealtimeRisk(point.lat, point.lon, runId) : null,
    enabled: !!point,
  });
}
